var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"editor_left"}},[(_vm.textoroutline == 0)?_c('editorLongNoveloutline'):_vm._e(),(_vm.textoroutline == 1)?_c('editorLongText'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }